(function(){
  // Skip if already shown this session
  if(sessionStorage.getItem('asp_popup'))return;

  var path=window.location.pathname;

  // Skip on cart / checkout
  if(path==='/cart')return;
  if(path.indexOf('/checkouts')===0)return;

  // Skip on pages where the visitor is actively using a form or account.
  // Popping an overlay while someone is filling name/email/message blocks
  // them from submitting. Exit-intent on these pages is worse than no popup.
  if(path==='/pages/contact-us')return;
  if(path.indexOf('/contact')===0)return;
  if(path==='/pages/free-room-analysis')return;
  if(path==='/pages/installation-guide')return;
  if(path.indexOf('/pages/quote')===0)return;
  if(path.indexOf('/account')===0)return;
  if(path.indexOf('/apps/')===0)return;

  // Skip if the page has a real (non-newsletter) form the visitor might be filling.
  // Runs after DOMContentLoaded so we don't false-positive on the minimal pre-hydration DOM.
  function hasActiveForm(){
    var forms=document.querySelectorAll('form');
    for(var i=0;i<forms.length;i++){
      var f=forms[i];
      // Ignore newsletter / list-manage forms (footer subscribe, etc.)
      if((f.action||'').indexOf('list-manage.com')!==-1)continue;
      if(f.querySelector('.mc-field-group'))continue;
      var typeInput=f.querySelector('input[name="form_type"]');
      if(typeInput && typeInput.value==='contact')return true;
      if(f.id==='ContactForm')return true;
      if((f.className||'').indexOf('contact-form')!==-1)return true;
    }
    return false;
  }

  // Skip for paid traffic (UTM parameters indicate ad click)
  var params=new URLSearchParams(window.location.search);
  var utmKeys=['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','gbraid','wbraid','fbclid','msclkid'];
  for(var i=0;i<utmKeys.length;i++){
    if(params.has(utmKeys[i])){
      sessionStorage.setItem('asp_paid_traffic','1');
      return;
    }
  }
  // Also skip if they arrived via paid traffic earlier in session
  if(sessionStorage.getItem('asp_paid_traffic'))return;

  // Defer the active-form check until the DOM is ready.
  function bind(){
    if(hasActiveForm())return;

    var shown=false;
    document.addEventListener('mouseout',function(e){
      if(shown)return;
      // Exit intent: pointer leaves the top of the viewport with no related target
      // (real exit toward the browser chrome). Stays as the ONLY trigger.
      // the previous 45-second auto-fire blocked users who were still filling forms.
      if(e.clientY<10 && e.relatedTarget===null){
        shown=true;
        sessionStorage.setItem('asp_popup','1');
        show();
      }
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',bind);
  }else{
    bind();
  }

  function show(){
    var o=document.createElement('div');
    o.id='asp-exit-popup';
    o.style.cssText='position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;';
    o.innerHTML='<div style="background:white;border-radius:12px;max-width:480px;width:100%;padding:36px;text-align:center;position:relative;"><button onclick="document.getElementById(\'asp-exit-popup\').remove()" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;color:#999;">&times;</button><div style="font-size:36px;margin-bottom:12px;">&#128203;</div><h2 style="color:#222222;margin:0 0 8px;font-size:22px;">Before You Go...</h2><p style="color:#666;margin:0 0 20px;font-size:15px;">Get our free <strong>Acoustic Panel Installation Guide</strong> - 10 chapters of expert advice on placement, mounting, and avoiding common mistakes.</p><a href="/pages/installation-guide" style="display:inline-block;background:#ea0606;color:#222222;padding:14px 28px;border-radius:6px;text-decoration:none;font-weight:700;font-size:16px;">Download Free Guide</a><p style="margin:16px 0 0;"><a href="/pages/free-room-analysis" style="color:#999;font-size:13px;">Or get a free personalized room analysis &rarr;</a></p></div>';
    o.addEventListener('click',function(e){if(e.target===o)o.remove();});
    document.body.appendChild(o);
  }
})();
